const PIN_STATES = {
  STAND: 'stand',
  DOWN: 'down',
  SPARE: 'spare',
};
const PIN_ORDER = [7, 8, 9, 10, 4, 5, 6, 2, 3, 1];
const STATE_STYLES = {
  [PIN_STATES.STAND]: {
    backgroundColor: '#45DA60',
  },
  [PIN_STATES.DOWN]: {
    backgroundColor: '#000',
  },
  [PIN_STATES.SPARE]: {
    backgroundColor: '#45DA60',
    border: '1px solid black',
  },
};
const ROWS = [
  { pins: [PIN_ORDER[0], PIN_ORDER[1], PIN_ORDER[2], PIN_ORDER[3]], cols: 4 },
  { pins: [PIN_ORDER[4], PIN_ORDER[5], PIN_ORDER[6]], cols: 3 },
  { pins: [PIN_ORDER[7], PIN_ORDER[8]], cols: 2 },
  { pins: [PIN_ORDER[9]], cols: 1 },
];

const getPinStandState = (intValue) => {
  let binaryString = intValue.toString(2).padStart(10, '0');
  let pins = [];
  binaryString
    .split('')
    .reverse()
    .forEach((bit, index) => {
      // the pin stand
      if (bit === '1') {
        pins.push(index + 1);
      }
    });
  return pins;
};

const calculatePinStates = (firstThrow, secondThrow) => {
  const firstThrowStates = getPinStandState(firstThrow || 0);
  const secondThrowStates = getPinStandState(secondThrow || firstThrowStates);

  return PIN_ORDER.map((pin) => {
    // Pin was knocked down in the first throw
    if (!firstThrowStates.includes(pin)) return PIN_STATES.DOWN;
    // Pin was standing after the first throw but knocked down in the second
    if (firstThrowStates.includes(pin) && !secondThrowStates.includes(pin))
      return PIN_STATES.SPARE;
    // Pin is still standing after both throws
    if (firstThrowStates.includes(pin) && secondThrowStates.includes(pin))
      return PIN_STATES.STAND;
    // Pin was down from the start or knocked down in the second throw
    return PIN_STATES.DOWN;
  });
};

// Row Component
const PinRow = ({ pins, cols, states }) => (
  <div
    className={`grid gap-0.5 justify-center`}
    style={{ gridTemplateColumns: `repeat(${cols}, 1fr)` }}
  >
    {pins.map((pin) => (
      <div
        key={pin}
        className="size-1.5 rounded-full text-white font-bold"
        style={STATE_STYLES[states[PIN_ORDER.indexOf(pin)]]}
      />
    ))}
  </div>
);

// Main Display Component
const PinDisplay = ({ values }) => {
  const [firstThrow, secondThrow] = values;
  const finalPinStates = calculatePinStates(firstThrow, secondThrow);

  return (
    <div className="flex flex-col justify-center items-center">
      {ROWS.map((row, index) => (
        <PinRow
          key={index}
          pins={row.pins}
          cols={row.cols}
          states={finalPinStates}
        />
      ))}
    </div>
  );
};

export default PinDisplay;
